import { setEnabledFeatures } from 'vue-feature-flipping';
import FeatureFlipping from 'vue-feature-flipping';

const isProduction = process.env.NODE_ENV === 'production';

let features = [];

function getDefaultFeatures()
{
  let defaultFeatures = [];
  // For experimental features:
  // Note: Docker images usually contain production builds, including the local Docker deployment.
  //       The 'client' deployment run via 'npm start' uses a development build.

  if(!isProduction) { // If not production build
    defaultFeatures.push("clause-admin"); // FLOW-4703: Customers should use "Documill Clause Library" tab in Salesforce-Leap instead, for now
    defaultFeatures.push("clause-storage-development-variants"); // Not planned to be made generally available
    defaultFeatures.push("clauses"); // FLOW-4657: Hide, unless Clauses are enabled in the organization via Salesforce. See enableFeature call in userInfo.js.
    defaultFeatures.push("salesforce-chatter-integration"); // Not good enough yet. See FLOW-4517.
  }

  defaultFeatures.push("overlay-annotations"); // DOS-2520: Enable overlay annotations in production builds
  defaultFeatures.push("overlay-signatures"); // FLOW-4264: Enable overlay signatures in productions builds
  defaultFeatures.push("simple-ux"); // DOS-2845: Enable Simpler UX for production.
  defaultFeatures.push("signature-page"); // DOS-3169 -> DOS-3440: Enable custom signature page in production.

  return defaultFeatures;
}

function enableDefaultFeatures() {
  let defaultFeatures = getDefaultFeatures();
  defaultFeatures.forEach(feature => features.push(feature));
  setEnabledFeatures(features);
}

function enableFeature(feature)
{
  if(features.indexOf(feature) >= 0)
    return // Already enabled

  features.push(feature);

  setEnabledFeatures(features);
}

function init(app)
{
  enableDefaultFeatures();
  app.use(FeatureFlipping);
}

export default {
  init,
  enableFeature
};
